import type { PrimaryContact } from '@core/billing-information-types';
import { createSingleEntityStore } from '@core/ngrx-legacy';

const { actions, selectors, reducer, namespace } = createSingleEntityStore<PrimaryContact>()(
  'PrimaryContactEntity',
  {
    customActions: adapter => ({
      update: (state, payload: { data: Partial<PrimaryContact>; isCreate: boolean }) =>
        adapter.markAsPending(state),
    }),
  },
);

export {
  actions as PrimaryContactEntityActions,
  selectors as PrimaryContactEntitySelectors,
  reducer as PrimaryContactEntityReducer,
  namespace as PrimaryContactEntityNamespace,
};
